/* eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import { mapGetters } from "vuex";
import readXlsxFile from 'read-excel-file'
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
Vue.component('multiselect', Multiselect)
export default {
  name: 'global-all-user-mail',
  components: {
    Multiselect
  },
  props: [],
  data() {
    return {
      selectUser: '',
      users: [],
      subject: '',
      message: '',
      userList: null,
      userListResults: [],
      value: [],
      options: [],
      submitted: false,
      multiselect: false,
      config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        }
      },
      confirmedSendMail: false,
      preview_box: false,
      UnsubscribedMultiple: false,
      unsubScribedmultiple: '',
      unsubScribedmultipleMail: [],
      unsubScribedmultiple_popup: false,
      excelImportDataList: [],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      readExcelFileLoader: false,
      confirmationDelieveredPopup: false,
      file: null,
      uploadAttachmentName: ''
    }
  },
  computed: {
    ...mapGetters([
      'isConditionalListOfAllUsersGetters'
    ]),
    getUserList() {
      this.userList = this.$store.getters.isConditionalListOfAllUsersGetters.data;
      return;
    },
    setIntialsState() {
      if (this.userList) {
        this.userListResults = this.userList
        for (var i = 0; i < this.userListResults.length; i++) {
          this.options.push({ first_name: this.userListResults[i].first_name, last_name: this.userListResults[i].last_name, email: this.userListResults[i].email, id: this.userListResults[i].id })
        }
      }
      return
    }
  },
  created() {
  },
  mounted() {
    this.getUserList
    this.setIntialsState
    this.createEditor()
  },
  methods: {
    clearUploadedFileMethod() {
      this.file = null
      this.uploadAttachmentName = ''
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      } else {
        this.uploadAttachmentName = '';
      }
    },
    confirmationDelieveredPopupClose() {
      this.confirmationDelieveredPopup = false;
      document.body.classList.remove('body_right_scroll_remove');
    },
    createEditor() {
      CKEDITOR.replace('message', {
        height: 350,
        allowedContent: true,
        onLoad: function () {
          CKEDITOR.addCss(
            'a{' +
            'color: #ffffff' +
            '}'
          );
        }
      });
      CKEDITOR.instances['message'].on('change', () => {
        var content1Length = CKEDITOR.instances['message'].getData().replace(/<[^>]*>/gi, '').length;
        if (content1Length > 0) {
          this.message = CKEDITOR.instances['message'].getData()
        } else {
          this.message = ''
        }
      })
    },
    onChange(value) {
      if (this.selectUser == 'Select Multiple') {
        this.multiselect = true
        this.UnsubscribedMultiple = false
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      } else if (this.selectUser == 'Unsubscribed Multiple') {
        this.multiselect = false
        this.UnsubscribedMultiple = true
        this.value = ''
      } else {
        this.multiselect = false
        this.UnsubscribedMultiple = false
        this.value = ''
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }
    },
    validateCreateMailBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.confirmedSendMail = true;
          document.body.classList.remove('email_sent_popup');
        }
      });
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    customLabel({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    adminAnnounNotfctnMethod(arg){
      if(arg == 'all_users'){
        let payload = {
          title: this.subject,
          message: this.message,
          url: '',
          send_to:"all"
        }
        this.$store.dispatch('adminAnnouncementAction', payload);
      }else if(arg == 'our_teams'){
        let payload = {
          title: this.subject,
          message: this.message,
          url: '',
          send_to:"team"
        }
        this.$store.dispatch('adminAnnouncementAction', payload);
      }else if(arg == 'selected_users'){
        let payload = {
          title: this.subject,
          message: this.message,
          url: '',
          send_to:"",
          user_ids:this.users,
        }
        this.$store.dispatch('adminAnnouncementAction', payload);
      }
    },
    yesConfirmed() {
      this.submitted = true;
      if (this.selectUser == 'Select Multiple') {
        for (var i = 0; i < this.value.length; i++) {
          this.users.push(this.value[i].id)
        }
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('message', this.message);
        formData.append('type', 'email');
        formData.append('users', JSON.stringify(this.users));
        if (this.file) {
          formData.append('file_attachment', this.file);
        }
        this.$store.dispatch('sentMultipleUserEmailFun', formData).then((res) => {
          toast.success(res.data.msg);
          document.body.classList.remove('email_sent_popup');
          this.adminAnnounNotfctnMethod('selected_users');
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = '';
          this.users = [];
          this.value = [];
          this.clearUploadedFileMethod();
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          document.body.classList.add('body_right_scroll_remove');
        });
      } else if (this.selectUser == 'Unsubscribed Multiple') {
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('message', this.message);
        formData.append('type', 'email');
        if (this.file) {
          formData.append('file_attachment', this.file);
        }
        if (this.excelImportDataList.length > 0) {
          let userArr = []
          Object.keys(this.excelImportDataList).map((index) => {
            if (this.isEmailValid(this.excelImportDataList[index][0]) == true) {
              userArr.push(this.excelImportDataList[index][0])
            }
          });
          formData.append('users', JSON.stringify(userArr));
        }
        if (this.unsubScribedmultipleMail.length > 0) {
          formData.append('users', JSON.stringify(this.unsubScribedmultipleMail));
        }
        this.$store.dispatch('sentUnsubscribedMultipleUserEmailFun', formData).then((res) => {
          toast.success(res.data.msg);
          document.body.classList.remove('email_sent_popup');
          this.submitted = false;
          this.confirmedSendMail = false;
          this.subject = '';
          // this.adminAnnounNotfctnMethod('selected_extrausers');
          this.unsubScribedmultipleMail = [];
          this.excelImportDataList = [];
          this.clearUploadedFileMethod();
          this.$validator.reset();
          this.confirmationDelieveredPopup = true;
          document.body.classList.add('body_right_scroll_remove');
        });
      } else if (this.selectUser == 'Testing') {
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('type', 'email');
        formData.append('message', this.message);
        if (this.file) {
          formData.append('file_attachment', this.file);
        }
        this.$store.dispatch('staffUserMailForTestingFun', formData).then((res) => {
          toast.success(res.data.msg);
          document.body.classList.remove('email_sent_popup');
          this.adminAnnounNotfctnMethod('our_teams');
          this.clearUploadedFileMethod();
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          document.body.classList.add('body_right_scroll_remove');
        });
      } else {
        let formData = new FormData();
        formData.append('subject', this.subject);
        formData.append('type', 'email');
        formData.append('message', this.message);
        if (this.file) {
          formData.append('file_attachment', this.file);
        }
        this.$store.dispatch('sentAllUserEmailFun', formData).then((res) => {
          toast.success(res.data.msg);
          document.body.classList.remove('email_sent_popup');
          this.adminAnnounNotfctnMethod('all_users');
          this.clearUploadedFileMethod()
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          document.body.classList.add('body_right_scroll_remove');
        });
      }
      return;
    },
    cancleConfirmed() {
      $('body').removeClass('email_sent_popup')
      this.submitted = false;
      this.confirmedSendMail = false
    },
    previewBtn() {
      this.preview_box = true
      $('body').addClass('email_sent_popup')
      setTimeout(() => {
        if (this.typeOfSelection == 'mobile') {
          document.getElementById("mailcode").innerHTML = this.sms_msg;
        } else {
          document.getElementById("mailcode").innerHTML = this.message;
        }
      }, 200)
    },
    closePreviewBtn() {
      this.preview_box = false
      $('body').removeClass('email_sent_popup')
    },
    unsubScribedmultipleMailPopupFun() {
      this.unsubScribedmultiple_popup = true
      $('body').addClass('email_sent_popup')
    },
    unsubScribedmultipleMailClosePopupFun() {
      this.unsubScribedmultiple_popup = false;
      document.body.classList.remove('email_sent_popup');
      document.getElementById("importEmail").value = null;
    },
    unsubScribedmultipleFun(e) {
      this.unsubScribedmultipleMail.push(this.unsubScribedmultiple)
      this.unsubScribedmultiple = ''
      this.$validator.reset();
    },
    removeAttributes: function (index) {
      Vue.delete(this.unsubScribedmultipleMail, index);
    },
    handleExcelFileUpload(event) {
      this.readExcelFileLoader = true
      this.excelImportDataList = []
      readXlsxFile(event.target.files[0]).then((res) => {
        this.excelImportDataList = res
        this.readExcelFileLoader = false
        this.unsubScribedmultipleMailClosePopupFun()
      })
    },
    isEmailValid(email) {
      return this.reg.test(email);
    },
    removeImportAttributes(index) {
      Vue.delete(this.excelImportDataList, index);

    },
    removeImportAttributesInPopup(index) {
      Vue.delete(this.excelImportDataList, index);
      if (this.excelImportDataList.length == 1) { document.getElementById("importEmail").value = null; }

    },
    addImportedEMailFun(e) {
      this.unsubScribedmultipleMail.push(this.excelImportDataList)
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
      this.$validator.reset();
    },
    removeImportedEMailFun() {
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
    }
  },
  watch: {
    getUserList() {
      return this.$store.getters.isConditionalListOfAllUsersGetters.data
    },
    userList(old_val, new_val) {
      if (new_val == undefined) {
        this.userListResults = old_val
        for (var i = 0; i < this.userListResults.length; i++) {
          this.options.push({ first_name: this.userListResults[i].first_name, last_name: this.userListResults[i].last_name, email: this.userListResults[i].email, id: this.userListResults[i].id })
        }
      }
    },
  }
}